import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import logo_unctad from '../../assets/logo-unctad.png';
import pessoas from '../../assets/pessoas.png';
import {
  Container,
  ContainerPeoples,
  ImageContainer,
  ImageContent,
  TextContent,
} from './style';
function Apresentation() {
  return (
    <Container id="1">
      <ImageContainer>
        <ImageContent>
          <ContainerPeoples>
            <img src={pessoas} alt="pessoas" />
          </ContainerPeoples>
          <TextContent>
            <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
              Reconhecido globalmente, o Empretec é um programa intensivo e
              transformador para empreendedores, criado pela ONU e exclusivo do
              Sebrae no Brasil. Uma metodologia prática que desenvolve
              habilidades fundamentais para empreender e identificar novas
              oportunidades de negócios.
            </BaSeParagraph>
            <img src={logo_unctad} alt="logo_unctad" width="60%" />
          </TextContent>
        </ImageContent>
      </ImageContainer>
    </Container>
  );
}

export default Apresentation;
